import OpenAI from 'openai';

let openai: OpenAI | null = null;
try {
  openai = new OpenAI({
    apiKey: import.meta.env.VITE_OPENAI_API_KEY || '',
    dangerouslyAllowBrowser: true
  });
} catch (err) {
  console.error('Failed to initialize OpenAI client:', err);
}

export async function generateMathProblem() {
  try {
    if (!openai) {
      throw new Error('OpenAI client not initialized');
    }

    const completion = await openai.chat.completions.create({
      messages: [{ 
        role: "user", 
        content: "Generate a simple math problem with a single-digit answer. Format it as JSON with 'question' and 'answer' fields. Example: {\"question\": \"3 + 5\", \"answer\": \"8\"}" 
      }],
      model: "gpt-3.5-turbo",
    });

    const content = completion.choices[0]?.message?.content;
    if (!content) throw new Error('No response from OpenAI');

    try {
      return JSON.parse(content);
    } catch (err) {
      console.error('Failed to parse OpenAI response:', content);
      throw new Error('Invalid response format');
    }
  } catch (err) {
    console.error('Error generating math problem:', err);
    // Use predefined problems as fallback
    const problems = [
      { question: "2 + 3", answer: "5" },
      { question: "4 + 1", answer: "5" },
      { question: "7 - 2", answer: "5" },
      { question: "9 - 4", answer: "5" },
      { question: "1 + 4", answer: "5" }
    ];
    return problems[Math.floor(Math.random() * problems.length)];
  }
}